{
  "details": "详情",
  "image": "活动图片",
  "startDate": "开始日期：{{date}}",
  "endDate": "结束日期：{{date}}",
  "rewardTarget": "奖励对象：VIP 等级 {{levels}}",
  "status": {
    "ongoing": "进行中",
    "ended": "已结束",
    "has-not-started": "未开始"
  }
}
